import { render } from "./MarketingCampaignCard.vue?vue&type=template&id=40be6d06"
import script from "./MarketingCampaignCard.vue?vue&type=script&lang=js"
export * from "./MarketingCampaignCard.vue?vue&type=script&lang=js"

import "./MarketingCampaignCard.vue?vue&type=style&index=0&id=40be6d06&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__